// extracted by mini-css-extract-plugin
module.exports = {"popModal":"wrapper_popModal__vxPgf","slideRight":"wrapper_slideRight__xubVJ","slideLeft":"wrapper_slideLeft__MZOR_","bottomModal":"wrapper_bottomModal__UyHlc"};